"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var Validator = require("validatorjs");
var ConfigBuilder = /** @class */ (function () {
    function ConfigBuilder() {
        this.clean();
    }
    ConfigBuilder.prototype.addMask = function (name, apply, clean) {
        this.config.masks = this.config.masks.concat([{ name: name, apply: apply, clean: clean }]);
        return this;
    };
    ConfigBuilder.prototype.addMasks = function (masks) {
        this.config.masks = this.config.masks.concat(masks);
        return this;
    };
    ConfigBuilder.prototype.addValidator = function (name, callback, errorMessage) {
        Validator.register(name, callback, errorMessage);
        return this;
    };
    ConfigBuilder.prototype.addValidatorAsync = function (name, callback, errorMessage) {
        Validator.registerAsync(name, callback, errorMessage);
        return this;
    };
    ConfigBuilder.prototype.setValidatorAttributeFormatter = function (func) {
        Validator.setAttributeFormatter(func);
        return this;
    };
    ConfigBuilder.prototype.addCustomMessages = function (lang, customMessages) {
        this.config.validation = { lang: lang, customMessages: customMessages };
        return this;
    };
    ConfigBuilder.prototype.fromLang = function (lang) {
        this.config = tslib_1.__assign({}, lang);
        return this;
    };
    ConfigBuilder.prototype.build = function () {
        return this.config;
    };
    ConfigBuilder.prototype.clean = function () {
        this.config = { masks: [], validation: null };
        return this;
    };
    return ConfigBuilder;
}());
exports.default = ConfigBuilder;
//# sourceMappingURL=builder.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@react-form-fields/core/config/builder.js
// module id = 683
// module chunks = 58